
import React, { useState } from "react";
import UpcomingBooking from "./MobileUpcomingBooking";
import MCompletedBooking from "./MCompletedBooking";
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const MobileMyBooking = () => {
  const navigate = useNavigate();

  const [activeButton, setActiveButton] = useState("hourly");
  const handleBack = () => {
    navigate(0);
  };

  return (
    <>
     <div className="w-full bg-[#FF9630] text-white py-4 px-6 flex items-center">
          <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
            <FaArrowLeft className="text-lg" />
          </button>
          <h1 className="text-xl font-semibold">My Bookings</h1>
        </div>
      <div className="w-full  flex items-start justify-center mt-6">
       
        <div className="w-full h-auto flex flex-col items-center justify-center gap-12">
          <div className="flex space-x-4 bg-[#FFF2C6] p-1 rounded-xl">
            <button
              onClick={() => setActiveButton("hourly")}
              className={`py-1 px-6 rounded-full ${activeButton === "hourly" ? "bg-[#FF9630] text-white" : "text-gray-600"
                }`}

            >
              UpComing
            </button>

            <button
              onClick={() => setActiveButton("subscription")}
              className={`py-1 px-6 rounded-full ${activeButton === "subscription" ? "bg-[#FF9630] text-white" : "text-gray-600"
                }`}
            >
              Completed
            </button>
          </div>
        </div>
      </div>

      {/* Conditional Rendering */}
      <div className="flex justify-center mt-6">
        {activeButton === "hourly" ? <UpcomingBooking /> : <MCompletedBooking />}
      </div>
    </>
  );
};

export default MobileMyBooking;
